/* eslint-disable react/destructuring-assignment */
import React from 'react'
import { CustomerServiceTelephone } from '@mobi/component-library/Base/Link'
import { NoticeBox } from '@core/Components/NoticeBox'
import { FailedSaveMessageContainer } from './FailedSaveMessage.styles'

export class FailedSaveMessage extends React.Component<{ showFailedMessage: boolean }> {
  private element: HTMLDivElement | null = null

  public componentDidUpdate() {
    // on error scrolls to the error
    if (this.element && this.element.scrollIntoView) {
      this.element.scrollIntoView()
    }
  }

  public render() {
    if (!this.props.showFailedMessage) {
      return null
    }

    return (
      <FailedSaveMessageContainer
        ref={(node: HTMLDivElement | null) => {
          this.element = node
        }}
      >
        <NoticeBox title='Failed to save your contact details' noticeBoxType='Error' hasBorder>
          <p>
            Please try again or call <CustomerServiceTelephone /> for assistance.
          </p>
        </NoticeBox>
      </FailedSaveMessageContainer>
    )
  }
}
